
export default function Footer() {
  return (
    <footer className="bg-[#14B8A6] text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/2fb37805-8251-4182-9787-cb5a44bb30ab.png" 
              alt="Caribbean Fashion Fest" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-white/80 leading-relaxed">
              Where Caribbean design meets global fashion
            </p>
          </div>

          <div>
            <h4 className="text-sm tracking-widest mb-4">QUICK LINKS</h4>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => document.getElementById('tickets')?.scrollIntoView({ behavior: 'smooth' })} className="text-white/80 hover:text-white transition-colors cursor-pointer">Tickets</button></li>
              <li><button onClick={() => document.getElementById('schedule')?.scrollIntoView({ behavior: 'smooth' })} className="text-white/80 hover:text-white transition-colors cursor-pointer">Schedule</button></li>
              <li><button onClick={() => document.getElementById('designers')?.scrollIntoView({ behavior: 'smooth' })} className="text-white/80 hover:text-white transition-colors cursor-pointer">Designers</button></li>
              <li><button onClick={() => document.getElementById('venue')?.scrollIntoView({ behavior: 'smooth' })} className="text-white/80 hover:text-white transition-colors cursor-pointer">Venue</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm tracking-widest mb-4">CONNECT</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="mailto:info@caribbeanfashionfest.com" className="text-white/80 hover:text-white transition-colors">Email</a></li>
              <li><a href="tel:+18095550123" className="text-white/80 hover:text-white transition-colors">Phone</a></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors">Press Kit</a></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors">Media Inquiries</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm tracking-widest mb-4">FOLLOW</h4>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 hover:bg-white hover:text-[#14B8A6] transition-all cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 hover:bg-white hover:text-[#14B8A6] transition-all cursor-pointer">
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 hover:bg-white hover:text-[#14B8A6] transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/70">
          <p>© 2025 Caribbean Fashion Fest. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
